import qs from "query-string"
import { setterAction, createAction } from "../common/redux"
import tracker from "../common/tracker"
import * as t from "./actionTypes"
import Source from "../interview/Source"
import * as embedActions from "../embed/actions"
import * as feedbackActions from "../feedback/actions"
import * as interviewActions from "../interview/actions"
import * as integrationActions from "../integration/actions"
import * as generator from "../chatItemGenerator"
import { captureException } from "../common/error"
import { getFollowUpOptions } from "../feedback/actions"

export const setCompleted = setterAction(t.SET_COMPLETED)
export const setCompletedTime = setterAction(t.SET_COMPLETED_TIME)
export const setResults = createAction(t.SET_RESULTS, "results")
export const setIsAlarm = setterAction(t.SET_IS_ALARM)
export const setAgreement = createAction(
  t.SET_DIAGNOSIS_AGREEMENT,
  "index",
  "agree"
)
export const setHelpfulness = createAction(
  t.SET_DIAGNOSIS_HELPFULNESS,
  "index",
  "agree"
)
export const setFeedback = setterAction(t.SET_FEEDBACK)
export const setHideFeedback = setterAction(t.SET_HIDE_FEEDBACK)
export const setSubmitted = setterAction(t.SET_SUBMITTED)
export const setDiagnosisExpand = createAction(t.SET_DIAGNOSIS_EXPAND, "index")
export const setEmail = setterAction(t.SET_EMAIL)
export const setPhoneNumber = setterAction(t.SET_PHONE_NUMBER)
export const setShowTipModal = setterAction(t.SET_SHOW_TIP_MODAL)
export const setShowFollowUpModal = setterAction(t.SET_SHOW_FOLLOW_UP_MODAL)
export const setShowFollowUpCard = setterAction(t.SET_SHOW_FOLLOW_UP_CARD)
export const setProfileInterestSubmitted = setterAction(
  t.SET_PROFILE_INTEREST_SUBMITTED
)
export const setProfileInterestEmail = setterAction(
  t.SET_PROFILE_INTEREST_EMAIL
)
export const setProfileInterestError = setterAction(
  t.SET_PROFILE_INTEREST_ERROR
)
export const setProfileInterestAttempted = setterAction(
  t.SET_PROFILE_INTEREST_ATTEMPTED
)
export const showProfileInterestConfirmation = setterAction(
  t.SHOW_PROFILE_INTEREST_CONFIRMATION
)

export const processResults = (results, isAlarm, review) => (
  dispatch,
  getState
) => {
  let { brand } = getState()
  const shouldFetchRecommendations =
    !isAlarm ||
    (isAlarm && (results.triage.level === 1 || results.triage.level === 7))

  dispatch(setCompleted(true))
  // Seperate completion time action because setting this when setting
  // completed would make the reducer and impure function
  dispatch(setCompletedTime(new Date()))
  dispatch(interviewActions.setLoading(false))
  if (
    results &&
    results.differential &&
    results.triage &&
    (results.differential.length > 0 || isAlarm)
  ) {
    let gated = false
    if (
      brand &&
      brand.visit_chat &&
      brand.visit_chat.settings.skip_collection === "Test"
    ) {
      if (results.triage.level === 7) {
        // non-gated for emergencies
        dispatch(embedActions.updateBrandGating(false))
      } else {
        // gated for max symptom duration <= 24 hours
        gated = true
        dispatch(embedActions.updateBrandGating(true))
      }
    } else if (brand && brand.skip_collection === "Half") {
      // 50/50 for Steward completions
      gated = Math.random() > 0.5
      dispatch(embedActions.updateBrandGating(gated))
    } else if (
      (brand &&
        brand.visit_chat &&
        !brand.visit_chat.settings.skip_collection) ||
      !brand
    ) {
      // by default brands won't skip email collection (ie. gated)
      gated = true
      dispatch(embedActions.updateBrandGating(true))
    }

    dispatch(getFollowUpOptions())
    dispatch(setResults(results))
    dispatch(setIsAlarm(isAlarm))

    if (brand && gated) {
      tracker.contactInfoQuestionShown()
      return dispatch(
        interviewActions.addChatItems([
          generator.preparingResults(brand),
          generator.emailQues(),
        ])
      )
    }

    // Skip insurance/employer capture step for alarm diagnosis and brand subdomains
    if (!isAlarm && brand && brand.owner === "Buoy" && !review) {
      return dispatch(integrationActions.initInsuranceCapture())
    }

    if (!review && shouldFetchRecommendations) {
      dispatch(integrationActions.getVisitRecommendations())
    } else {
      dispatch(showResults(review))
    }
  } else {
    dispatch(interviewActions.addChatItem(generator.emptyCompletion()))
  }

  if (!review) {
    tracker.completion(results.differential.length, isAlarm)
  }
}

export const showResults = (review = false) => (dispatch, getState) => {
  const { brand, integration, completion } = getState()
  const { level } = completion.results.triage
  const showZip =
    integration && integration.length > 0 && integration.some(i => i.show_zip)
  let items = []

  if (review) {
    return dispatch(interviewActions.addChatItem(generator.completion()))
  }

  if (brand.name && brand.gated) {
    items.push(generator.resultsDisclaimer())
  } else {
    items.push(generator.preparingResults(brand), generator.resultsDisclaimer())
  }

  if (showZip) {
    items.push(generator.zipcodePrompt())
  }

  dispatch(interviewActions.addChatItems([...items, generator.completion()]))

  if (
    level < 6 &&
    ((!integration.configuredExperience && brand.name === "public") || // show to public
    integration.configuredExperience === "ma_covid" || // show ma_covid on prod
    brand.name === "ma-gov" || // show ma_covid on staging / sandbox / local
    integration.configuredExperience === "humana_01_commercial" || // show to humana
    integration.configuredExperience === "humana_02_medicare" // show to humana
    )
  ) {
    dispatch(handleNps())
    Source.askFollowUp()
      .then(data => {
        if (data.ask_follow_up) dispatch(setShowFollowUpCard(true))
      })
      .catch(error => {
        console.log(error)
      })
  }
}

export const handleNps = () => (dispatch, getState) => {
  const { brand, feedback } = getState()

  if (brand.name === "public") {
    Source.shouldGetNps()
      .then(data => {
        dispatch(feedbackActions.setGetNpsFeedback(data.get_nps))

        if (data.get_nps) {
          dispatch(feedbackActions.showNpsCard(true))
          Source.lastAskedNps(true)
        } else {
          // Show the tipping modal if NPS feedback doesn't show
          if (window.tip_popup_time) {
            setTimeout(() => {
              dispatch(feedbackActions.showNpsCard(true))
              Source.lastAskedNps(true)
            }, 20000)
          } else {
            // Show the tipping modal if NPS feedback doesn't show
            if (window.tip_popup_time && !feedback.showPostIntentPopUp) {
              setTimeout(() => {
                dispatch(setShowTipModal(true))
              }, window.tip_popup_time)
            }
          }
        }
      })
      .catch(captureException)
  }
}

export const emailPhoneSubmit = brandName => (dispatch, getState) => {
  let { completion } = getState()
  let { email, results, phoneNumber } = completion
  let query = qs.parse(window.location.search)

  if (query.symptom_test) {
    Source.emailResults(email, brandName)
  } else {
    Source.requestReport(email, phoneNumber.replace(/\D/g, ""), brandName)
      .then(() => {
        Source.emailResults(email, brandName)
      })
      .catch(captureException)
  }

  tracker.completion(results.differential.length, results.alarm)
  if (!results.alarm) dispatch(integrationActions.getVisitRecommendations())
}

export const emailSummaryReport = (email, first, last, optIn) => (
  dispatch,
  getState
) => {
  const { brand } = getState()

  let questions = []

  return Source.requestReport(
    email,
    undefined,
    brand.name,
    first,
    last,
    optIn,
    JSON.stringify(questions)
  )
    .then(Source.emailResults(email, brand.name))
    .catch(captureException)
}

export const complete = () => dispatch => {
  dispatch(interviewActions.setLoading(true, "completion/complete"))
  Source.results()
    .then(data => {
      dispatch(processResults(data.results, data.is_alarm))
    })
    .catch(error => dispatch(interviewActions.genericError(error)))
}

export const setDiagnosisAgreement = (index, agree) => (dispatch, getState) => {
  let { results } = getState().completion
  dispatch(setAgreement(index, agree))
  let token = results.differential[index].token

  Source.diagnosisAgreement(token, agree)
  if (agree) {
    tracker.diagnosisConfirmed()
    setTimeout(() => dispatch(setHideFeedback(true)), 5000)
  } else {
    tracker.diagnosisDenied()
  }
}

export const setDiagnosisHelpfulness = (index, agree) => (
  dispatch,
  getState
) => {
  let { results } = getState().completion
  dispatch(setHelpfulness(index, agree))
  let token = results.differential[index].token

  Source.diagnosisHelpfulness(token, agree)
  if (agree) {
    tracker.helpfulnessConfirmed()
  } else {
    tracker.helpfulnessDenied()
  }
}

export const submitFeedback = () => (dispatch, getState) => {
  let { feedback, results } = getState().completion
  dispatch(setSubmitted(true))
  dispatch(setFeedback(""))
  let token = results.differential[0].token

  Source.differentialFeedback(token, feedback)
    .then(() => {
      setTimeout(() => dispatch(setHideFeedback(true)), 5000)
    })
    .catch(captureException)
}

export const submitProfileInterestEmail = reasonText => (
  dispatch,
  getState
) => {
  let { completion, identifiers } = getState()
  let { profileInterest } = completion
  const { profile_id } = identifiers
  const { email } = profileInterest

  Source.recordProfileInterestEmail(profile_id, email, reasonText)
    .then(() => {
      dispatch(setProfileInterestError(null))
      dispatch(setProfileInterestSubmitted(true))
      dispatch(showProfileInterestConfirmation(true))
    })
    .catch(() => {
      dispatch(
        setProfileInterestError("Something went wrong. Please try again!")
      )
    })
}

export const startSectionTracker = section_title => () => {
  Source.startSectionTracker(section_title).catch(captureException)
}

export const endSectionTracker = section_title => () => {
  Source.endSectionTracker(section_title).catch(captureException)
}

export const sectionActionTracker = (section_title, action) => {
  Source.sectionActionTracker(section_title, action).catch(captureException)
}

export const clickLinkTracker = url => {
  Source.clickLinkTracker(url).catch(captureException)
}



// WEBPACK FOOTER //
// ./assets/completion/actions.js